import React, { useState } from 'react';
import ConfirmationBlock from '../ConfirmationBlock';
import deleteImg from '../../../assets/images/warning-gif.gif';
import confirmImg from '../../../assets/images/confirm-gif.gif';
import Button from '../../molecules/Button';
import { useNavigate } from 'react-router-dom';

const DeleteMember = () => {
  const navigate = useNavigate();
  const [confirmDelete, setConfirmDelete] = useState(false);
  return (
    <div>
      {!confirmDelete ? (
        <ConfirmationBlock
          img={deleteImg}
          title="Delete this Member!"
          description="Are you sure you want to delete this member? all data will be lost."
          btns={
            <>
              <Button onClick={() => navigate('/my-team')}>Cancel</Button>
              <Button variant="danger" onClick={() => setConfirmDelete(true)}>
                Delete
              </Button>
            </>
          }
        />
      ) : (
        <ConfirmationBlock
          img={confirmImg}
          title="Deleted Successfully!"
          btns={<Button onClick={() => navigate('/my-team')}>Go Back</Button>}
        />
      )}
    </div>
  );
};

export default DeleteMember;
